import {User} from "../models/user";
import {
    LOAD_LOGGED_IN_FAILED, LOGGING_IN, LOGIN_COMPLETE, SECURITY_API_ERROR,
    SecurityAction
} from "../actions/security";

export interface SecurityState {
    user?: User;
    loading?: boolean;
    errorMessage?: string;
    loadLoggedInFailed?: boolean;
}

const initialState = (): SecurityState => {
    return {};
};

export function securityReducer(state: SecurityState = initialState(), action: SecurityAction): SecurityState {
    switch (action.type) {
        case LOGGING_IN:
            return {
                ...state,
                loading: true
            };
        case LOGIN_COMPLETE:
            return {
                ...state,
                user: action.user,
                loading: false,
                loadLoggedInFailed: false
            };
        case SECURITY_API_ERROR:
            return {
                ...state,
                user: null,
                loading: false,
                errorMessage: action.errorMessage
            };
        case LOAD_LOGGED_IN_FAILED:
            return {
                ...state,
                loading: false,
                user: null,
                loadLoggedInFailed: true
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/security.ts